export class DeleteFleetUserResponse {
    userId?: string;
}